import { instance, next } from "./base";

const BASE = "/api/v1/admin/monitoring";

const get = (url, params) =>
  instance()
    .get(`${BASE}${url}`, { params })
    .then(({ data }) => data?.data)
    .catch((e) => next(e));
const send = (method, url, body) =>
  instance()
    [method](`${BASE}${url}`, body)
    .then(({ data }) => data?.data)
    .catch((e) => next(e));

export const getDashboard = () => get("/dashboard");
export const getAlerts = (params) => get("/alerts", params);
export const getAlert = (id) => get(`/alerts/${id}`);
export const updateAlert = ({ id, ...body }) => send("patch", `/alerts/${id}`, body);
export const releaseHold = (id) => send("post", `/alerts/${id}/release`, {});
export const rejectHold = ({ id, reason }) => send("post", `/alerts/${id}/reject`, { reason });
export const escalateAlert = ({ id, ...body }) => send("post", `/alerts/${id}/escalate`, body);

export const getCases = (params) => get("/cases", params);
export const getCase = (id) => get(`/cases/${id}`);
export const updateCase = ({ id, ...body }) => send("patch", `/cases/${id}`, body);

export const getRules = () => get("/rules");
export const updateRule = ({ key, ...body }) => send("patch", `/rules/${key}`, body);
export const simulateRule = ({ key, ...body }) => send("post", `/rules/${key}/simulate`, body);

export const getMonitoringSettings = () => get("/settings");
export const updateMonitoringSettings = (body) => send("patch", "/settings", body);

export const getAudit = (params) => get("/audit", params);
export const getCustomerMonitoring = (userId) => get(`/customers/${userId}`, { days: 30 });
export const rescanCustomer = (userId) => send("post", `/customers/${userId}/rescan`, {});
